// extracted by mini-css-extract-plugin
export default {"configHeading":"TeamSettingsSection_configHeading__QRbdw","configFields":"TeamSettingsSection_configFields__732K2","actionsRow":"TeamSettingsSection_actionsRow__+ECy1"};